export const CrmGraphql = {
  QueryNameSpace: 'crm_query',
  NameSpace: 'crm'
};
